import actionTypes from './types'
import groupTypes from './groups'

/**
 * Update an option
 * @param {*} step 
 */
export const setOption = ( key = '', value = null, group = null ) => ( {
  type: actionTypes.SET_OPTION,    
  payload: { key, value, group }
} )

/**
 * Update a filter option
 * @param {*} step 
 */
 export const setFilterOption = ( key = '', value = null ) => ( {
  type: actionTypes.SET_OPTION,    
  payload: { key, value, group: groupTypes.FILTERS }
} )

/**
 * Update a filter option
 * @param {*} step 
 */
 export const resetFilters = () => ( {
  type: actionTypes.SET_OPTION,    
  payload: { key: groupTypes.FILTERS, value: {} }
} )

/**
 * Update a homepage option
 * @param {*} step 
 */
 export const setHomeOption = ( key = '', value = null ) => ( {
  type: actionTypes.SET_OPTION,    
  payload: { key, value, group: groupTypes.HOMEPAGE }
} )

/**
 * Update a grouppage option
 * @param {*} step 
 */
 export const setGroupOption = ( key = '', value = null ) => ( {
  type: actionTypes.SET_OPTION,    
  payload: { key, value, group: groupTypes.GROUPPAGE }
} )

/**
 * Update a carpage option
 * @param {*} step 
 */
 export const setCarOption = ( key = '', value = null ) => ( {
  type: actionTypes.SET_OPTION,    
  payload: { key, value, group: groupTypes.CARPAGE }
} )

/**
 * Store the favourite cars
 * @param {Array<number>} favourites favourite start numbers
 * @returns {Object} action
 */
export const setFavourites = ( favourites = [] ) => ( {
  type: actionTypes.SET_OPTION,
  payload: { key: 'favourites', value: favourites }
} )

/**
 * Store the table options of one screen, such as its sorting
 * @param {string} context screen the table is on
 * @param {Object} value table options of that screen
 * @returns {Object} action
 */
export const setTableOption = ( context = '', value = {} ) => ( {
  type: actionTypes.SET_OPTION,
  payload: { key: context, value, group: groupTypes.TABLE }
} )



/**
 * Store an option of the kiosk screen
 * @param {string} key option name
 * @param {boolean|number} value new value
 * @returns {Object} action
 */
export const setKioskOption = ( key = '', value = null ) => ( {
  type: actionTypes.SET_OPTION,
  payload: { key, value, group: groupTypes.KIOSK }
} )
